import { render, staticRenderFns } from "./integrations-store.vue?vue&type=template&id=30588d5a&scoped=true"
import script from "./integrations-store.vue?vue&type=script&lang=js"
export * from "./integrations-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30588d5a",
  null
  
)

export default component.exports